module.exports = __webpack_public_path__ + "static/img/logo.ded98b72.png";